import { useState, useRef } from "react";

import {
  getFincasAAFF,
  getFincasTech,
  getSuppListPropertiAaff,
} from "../services";
import { useContext } from "react";
import { UsuarioContext } from "../providers/userContext";
import { Link } from "react-router-dom";
import {
  diferenciaMesesCaducidad,
  formatoFechasEs,
  ventaMasReciente,
  GRUPOS_SERVICIO,
} from "../functions/funciones";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  useRecogerURLParamsFiltros,
  construirURLParamsFiltros,
} from "./../functions/parametrosURL/funcionesParamsURL";

function useComunidades(busqueda) {
  const user = useContext(UsuarioContext);

  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const [loading, setLoading] = useState(true);
  const { filtroOrder } = useRecogerURLParamsFiltros();

  const navigate = useNavigate();
  const isFetchingRef = useRef(false);

  const fetchData = async ({
    offset,
    limit,
    filtros = busqueda,
    order,
    orderBy,
  } = {}) => {
    // Prevenir llamadas duplicadas simultáneas
    if (isFetchingRef.current) {
      return;
    }

    orderBy = orderBy || filtroOrder.ordenadoPor || "id";
    order = order || filtroOrder.orden || "ASC";

    const payload = {
      params: { page: offset, limit: limit, order, orderBy },
      filtros,
    };
    
    try {
      isFetchingRef.current = true;
      setLoading(true);
      let response = [];
      if (user.rol === "SUPP") {
        response = await getSuppListPropertiAaff(payload);
      } else if (user.rol === "TECH" || user.rol === "TECH_COOR") {
        response = await getFincasTech(payload);
        const listado = [];
        response.data.forEach((res) => {
          listado.push(res);
        });
        response.data = listado;
      } else {
        response = await getFincasAAFF(payload);
      }

      const { meta, data } = response;
      
      // Construir URL después de obtener los datos exitosamente
      construirURLParamsFiltros(
        navigate,
        offset || 1,
        limit || 50,
        filtros,
        order,
        orderBy
      );
      
      setData({
        meta,
        rows: formatData(data, meta),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  const formatData = (data, meta) => {
    const formattedData = [];
    data.map((row, i) => {
        // const diferenciaMeses = diferenciaMesesCaducidad(row.fechaRenovacion, row.createdAt)
      const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
      const sale_lopd = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.lopd);
      const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
      const instalacion_kae = row?.instalacionesKae?.find(i => i.prop_id === row.id) || null;
      formattedData.push({
        id_main_property: row.id,
        i: (meta.current_page - 1) * meta.per_page + (i + 1),
        aaff: row.aaff,
        finca:
          user.rol === "SUPP"
            ? row
            : {
                ...row,
                properties: { nif: row.nif },
                detailsCae: row.sales[0]?.detailsCae,
              },
        sales: row.workcenters && row.workcenters.length > 0 ? [] : row.sales,
        aaff_id: row?.aaff?.id,
        aaff_nif: row?.aaff?.nif,
        commer_id: row?.aaff?.commer_id,
        tech_id: row?.aaff?.tech_id,
        razonSocial: row.aaff?.razonSocial,
        nif: row.nif,
        id: row.id,
        community: row.razonSocial || row.propertie?.razonSocial,
        community_name: row.razonSocial || row.propertie?.razonSocial,
        direccion: row.direccion || row.propertie?.direccion,
        codigoPostal: row.codigoPostal || row.propertie?.codigoPostal,
        municipio: row.municipio || row.propertie?.municipio,
        empleados: row.trabajadores === null ? false : row.trabajadores,
        createdAt: formatoFechasEs(row.createdAt),
        fechaUltVisita:
          row.workcenters && row.workcenters.length === 0
            ? row.visitSheets?.[0]?.createdAt
              ? formatoFechasEs(row.visitSheets[0].createdAt)
              : null
            : null,
        centrosTrabajo: row.workcenters,
        // btn_to: <Link to={`/comunidades/${row.nif}`} className="btn btn-light"><FaEye /></Link>,
        hojasVisita: row.nif,
        isWorkcenter: false,
        // caducada: diferenciaMeses > 13 ? true : false
        saleCae_id: sale_cae?.id || null,
        saleLopd_id: sale_lopd?.id || null,
        saleCai_id: sale_cai?.id || null,
        instalacionKae_id: instalacion_kae?.id || null,
        estadoCae: sale_cae
          ? sale_cae.estado_id === null
            ? 1
            : sale_cae.estado_id
          : "-",
        estadoLopd: sale_lopd
          ? sale_lopd.estado_id === null
            ? 1
            : sale_lopd.estado_id
          : "-",
        estadoCai: sale_cai
          ? sale_cai.estado_id === null
            ? 1
            : sale_cai.estado_id
          : "-",
        estadoKae: instalacion_kae
          ? instalacion_kae.estado_id === null
            ? 1
            : instalacion_kae.estado_id
          : "-",
      });
      if (row.workcenters?.length > 0) {
        row.workcenters?.forEach((wc) => {
          formattedData.push({
            id_main_property: row.id,
            i: "",
            id: wc.id,
            aaff: row.aaff,
            finca: wc,
            sales: wc.workSales,
            aff_name: "",
            community: wc.razonSocial,
            nif: "",
            fechaAlta: "",
            fechaUltVisita: wc.visitSheets?.[0]?.createdAt
              ? formatoFechasEs(wc.visitSheets[0].createdAt)
              : null,
            direction: "",
            cp: "",
            municipio: "",
            empleados: "",
            isWorkcenter: true,
            estadoCae: "",
            estadoLopd: "",
            estadoCai: "",
            estadoKae: "",
            saleCae_id: "",
            saleLopd_id: "",
            saleCai_id: "",
            instalacionKae_id: "",
          });
        });
      }
    });
    return formattedData;
  };

  return {
    data,
    fetchData,
    loading,
  };
}

export default useComunidades;